<template>
  <v-alert type="info"
           tile>
    Pasting from Microsoft Word creates messy code that disrupts formatting.<br/>
    To prevent this, use <code class="text-no-wrap font-weight-bold">CTRL+SHIFT+V</code> (or <code class="text-no-wrap font-weight-bold">CMD+SHIFT+V</code> on a mac) to paste as plain text.<br/>
    You can then reapply formatting as needed for a clean and consistent result.
  </v-alert>
</template>
<script>
export default {

}
</script>
